// extracted by mini-css-extract-plugin
export default {"wrapper":"carousel-controls-module--wrapper--3f8d1"};